import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ConsultationRequest from "./sections/ConsultationRequest";
import SpecialtyFaq from "./sections/SpecialtyFaq";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ConsultationRequest />
      <SpecialtyFaq />
      <Footer />
    </div>;
}